import React, {useState} from 'react'
import styled from 'styled-components'
import { Row, Col, Card as CardBase, CardImg, CardBody, CardFooter } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import thumbnailNotAvailable from 'img/image-not-available.png'
import cn from 'classnames'

const Wrapper = styled.div.attrs({
  className: 'col card-wrapper'
})``

const Card = styled(CardBase).attrs({
  className: 'rounded-3'
})`
  transition: 0.15s;
  border-color: var(--bs-gray-300);
  overflow: hidden;

  &:hover {
    border-color: var(--bs-primary);

    img {
      transform: scale(1.05);
    }

    .product-title {
      color: var(--bs-primary);
    }
  }
`

const Thumbnail = styled(CardImg).attrs({
  className: 'rounded-3 rounded-bottom-0'
})`
  cursor: pointer;
  transition: 0.3s;
  opacity: 1;
`

const ProductTitle = styled.h2.attrs({
  className: 'my-1 fw-semibold product-title'
})`
  font-size: 1.1rem;

  a {
    text-decoration: none;
    color: var(--secondary);
    transition: 0.5s ease;
  }
`

const ProductFooter = styled(CardFooter).attrs({
  className: 'py-2 px-3 rounded-3 rounded-top-0'
})`
  transition: 0.5s ease;
`

const Icon = styled.i`
  cursor: pointer;
  color: var(--bs-primary);
  font-size: 1.05rem;
  transition: 0.5s ease;

  &:hover {
    color: var(--secondary);
  }
`

const FeaturedPrice = styled.span`
  cursor: pointer;
  transition: 0.3s ease;
  border: 0px;
  border-radius: 0.15em;
  font-size: 0.9em;

  strong {
    font-size: 1.3em;
  }

  &:hover {
    color: var(--bs-primary);
  }
`
const ProductCard = (props) => {
  const {
    thumbnail,
    title,
    description,
    featured_price_label,
    onSelect
  } = props
  const {i18n} = useTranslation()
  const [isHover, setIsHover] = useState(false)

  return (
    <Wrapper>
      <Card onClick={onSelect} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)} className={cn(['h-100', isHover ? 'shadow' : 'shadow-sm'])}>
        {true &&
          <Thumbnail
            top
            width="100%"
            src={thumbnail || thumbnailNotAvailable}
            alt={title}
          />
        }

        <CardBody onClick={onSelect} style={{cursor: 'pointer'}}>
          <ProductTitle>
            <a href="#">
              {title}
            </a>
          </ProductTitle>

          {description &&
            <div>
              {description}
            </div>
          }
        </CardBody>

        <ProductFooter className={isHover ? 'bg-light' : 'bg-white'}>
          <div className="d-flex justify-content-end align-items-center">
            <div>
              {featured_price_label ?
                (
                  <FeaturedPrice onClick={(e) => e.preventDefault()}>
                    {i18n.t('product_card.from')} <strong className="h3 fw-bold">{featured_price_label}</strong>
                  </FeaturedPrice>
                ) : (
                  <strong className="h3" style={{ fontSize: '1.22em' }}>
                    {i18n.t('format:actions.see_more')}
                  </strong>
                )
              }
            </div>
          </div>
        </ProductFooter>
      </Card>
    </Wrapper>
  )
}

export default ProductCard
